export default {"src":"/_next/static/media/DG.59fb522a.svg","height":18,"width":18};